import { Box } from '@mui/material';

import { ReportWidgetChart } from '../ReportWidgetChart';
import { ReportWidgetTable } from '../ReportWidgetTable';

import type { ComposableWidgetLayoutProps } from '../../model/types';

export const ComposableWidgetStacked = ({
    chartItems,
    visibleItems,
    visualization,
    table,
    modelLabel,
    showChart,
    loading,
    isPrinting,
    disableChartAnimation,
    isInitialLoading,
    isLoadingMore,
    hasMore,
    handleLoadMore,
    loadMoreCount,
    canCollapse,
    handleCollapse,
    itemColors,
    rowClickHandler,
    detailsClickHandler,
    chartItemClickHandler,
    hoveredItemId,
    tableActiveItemId,
    chartHoverHandler,
    tableRowHoverHandler,
}: ComposableWidgetLayoutProps): JSX.Element => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            width: '100%',
            minWidth: 0,
            '& > *': {
                minWidth: 0,
            },
        }}
    >
        {showChart && (
            <ReportWidgetChart
                items={chartItems}
                chartType={visualization.type}
                options={visualization.options}
                modelLabel={modelLabel}
                loading={loading}
                isPrinting={isPrinting}
                disableAnimation={disableChartAnimation}
                onItemClick={chartItemClickHandler}
                activeItemId={hoveredItemId ?? undefined}
                onItemHover={chartHoverHandler}
            />
        )}

        {table.enabled && (
            <ReportWidgetTable
                items={visibleItems}
                columns={table.columns}
                modelLabel={modelLabel}
                loading={isInitialLoading}
                isPrinting={isPrinting}
                useStickyHeader={false}
                loadingMore={isLoadingMore}
                hasMore={hasMore}
                onLoadMore={handleLoadMore}
                canCollapse={canCollapse}
                onCollapse={handleCollapse}
                itemColors={itemColors}
                options={{
                    ...table.options,
                    loadMoreCount,
                }}
                onRowClick={rowClickHandler}
                onDetailsClick={detailsClickHandler}
                activeItemId={tableActiveItemId}
                onRowHover={tableRowHoverHandler}
            />
        )}
    </Box>
);
